import type { ZoneBounds, ZoneStyle, ZoneTransitions } from '@/types'

// Default aspect ratios
export const ASPECT_RATIOS = [
  { label: '16:9 (HD)', value: '16:9' },
  { label: '4:3 (Standard)', value: '4:3' },
  { label: '21:9 (Ultrawide)', value: '21:9' },
  { label: '1:1 (Square)', value: '1:1' },
  { label: '9:16 (Portrait)', value: '9:16' },
] as const

// Default zone bounds (full screen)
export const DEFAULT_ZONE_BOUNDS: ZoneBounds = {
  x: 0,
  y: 0,
  width: 100,
  height: 100,
  unit: 'percent',
}

// Default zone style
export const DEFAULT_ZONE_STYLE: ZoneStyle = {
  backgroundColor: 'transparent',
  borderRadius: 0,
  borderWidth: 0,
  borderColor: 'transparent',
  borderStyle: 'none',
  boxShadow: 'none',
  opacity: 1,
  overflow: 'hidden',
}

// Default zone transitions
export const DEFAULT_ZONE_TRANSITIONS: ZoneTransitions = {
  enter: { type: 'fade', duration: 300, easing: 'ease-out', delay: 0 },
  exit: { type: 'fade', duration: 200, easing: 'ease-in', delay: 0 },
}

// Video player defaults
export const VIDEO_DEFAULTS = {
  autoplay: true,
  loop: true,
  muted: true,
  volume: 1,
  playbackRate: 1,
  objectFit: 'contain' as const,
}

// Presentation defaults
export const PRESENTATION_DEFAULTS = {
  autoAdvance: true,
  advanceInterval: 10, // seconds
  loop: true,
  transition: 'fade' as const,
}

// Web content defaults
export const WEB_DEFAULTS = {
  refreshInterval: 0,
  allowInteraction: false,
  zoomLevel: 100,
}

// Display window defaults
export const DISPLAY_WINDOW_FEATURES = {
  width: 1920,
  height: 1080,
  menubar: 'no',
  toolbar: 'no',
  location: 'no',
  status: 'no',
  resizable: 'yes',
}

// Fullscreen re-entry settings
export const FULLSCREEN_REENTRY = {
  maxAttempts: 3,
  delay: 500, // milliseconds
}

// Auto-save interval
export const AUTO_SAVE_INTERVAL = 5000 // 5 seconds

// Ephemeral mode: when enabled the app runs without disk persistence.
// By default it is enabled unless explicitly disabled with VITE_EPHEMERAL_MODE=0.
export const EPHEMERAL_MODE = import.meta.env.VITE_EPHEMERAL_MODE !== '0'

// Grid snap options
export const GRID_SNAP_OPTIONS = [
  { label: 'Off', value: 0 },
  { label: '1%', value: 1 },
  { label: '2%', value: 2 },
  { label: '5%', value: 5 },
  { label: '10%', value: 10 },
] as const

// Minimum zone dimensions (percentage)
export const MIN_ZONE_SIZE = {
  width: 5,
  height: 5,
}
